// app/javascript/controllers/gfe_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.triggerTarget.setAttribute("aria-expanded", this.triggerTarget.checked)
  }

  switch() {
    const on = this.triggerTarget.checked
    this.contentTarget.classList.toggle("hidden", !on)
    this.contentTarget.classList.toggle("block", on)
    this.triggerTarget.setAttribute("aria-expanded", on)
  }
}
